import { useI18n } from '#/i18n/hooks/useI18n';
import { useSearchFacetsOrg } from '#/modules/search/constants/useSearchFacetsOrg';
import { useSearchQuery } from '#/modules/search/contexts/SearchContext';
import { SearchPage } from '#/modules/search/pages/Search/SearchPage';

export function SearchOrgsPage() {
  const { i18n } = useI18n();

  const query = useSearchQuery();

  const { orgSearchFacets } = useSearchFacetsOrg(i18n);

  return (
    <SearchPage
      searchType="ORG"
      showSortOptions={Boolean(query)}
      searchFacets={orgSearchFacets}
    />
  );
}
